import './header.scss';

const COMPONENT_NAME = 'tcl-header';

const BEM = {
  BLOCK: COMPONENT_NAME,
  HEADER_BURGER: 'tcl-header__actions__item',
  MEGAMENU: 'header-megamenu',
};

/**
 * version    1.0
 * class      <type> (Header)
 * classdesc  Component that manage the page header
 */
export class Header {
  constructor() {
    this._els = {
      body: $('body'),
      header: $(`.${BEM.BLOCK}`),
      headerBurger: $(`.${BEM.HEADER_BURGER}`),
      megamenu: $(`.${BEM.HEADER_MEGAMENU}`),
    };

    this._bindEvents();
  }

  // private methods

  _bindEvents() {
    const self = this;

    self._els.headerBurger.on('click', () => this.toggleMenu());
    this.openSearchModal();
    this.initSearchInput();
    this.closeSearchModal();
    this.changeInputVal();
    self._els.megamenu.find('.tcl-header__actions .tcl-header__actions__item').on('click', () => this.toggleMenu());
  }

  toggleMenu() {
    if ($('.header-megamenu').hasClass('header-megamenu--open')) {
      $('.header-megamenu').removeClass('header-megamenu--open');
      $('body').removeClass('no-scroll');
    } else {
      $('.header-megamenu').addClass('header-megamenu--open');
      $('body').addClass('no-scroll');
    }
  }

  openSearchModal() {
    $('.tcl-header__actions__search').on('click', () => {
      $('body').addClass('search-modal-open');
    });
  }

  closeSearchModal() {
    $('.modal--full-screen-header-visible .modal-close').on('click', () => {
      $('body').removeClass('search-modal-open');
    });
  }

  initSearchInput() {
    const searchInput = $('.search-input');
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const searchedVal = urlParams.get('searchedVal');

    if (searchInput.length > 0) {
      searchInput.each(function () {
        if (searchedVal && searchedVal.length > 0) {
          $(this).val(searchedVal);
          $(this).attr('value', searchedVal);
          $(this).closest('.search-form').find('.form-search-label p span').text(searchedVal);
        }
      });
    }
  }

  changeInputVal() {
    const searchInput = $('.search-input');

    if (searchInput.length > 0) {
      searchInput.each(function () {
        $(this).on('change paste keyup', function () {
          $(this).attr('value', $(this).val());
        });

        $(this).next().on('click', function () {
          // Ottieni la base URL fino alla lingua (es: /it/ o /en/)
          const pathMatch = window.location.pathname.match(/^(.*?\/(it|en)\/)/);
          const basePath = pathMatch ? pathMatch[0] : '/it/'; // fallback su /it/
          const searchValue = $(this).prev().val();
          window.location.href = `${basePath}search_result.page?search=${encodeURIComponent(searchValue)}`;
        });
      });
    }
  }
}
